module.exports = __webpack_public_path__ + "img/portraitMale.1328f100.svg";